import { render, staticRenderFns } from "./CartoonDetail.vue?vue&type=template&id=3683d7ca&scoped=true"
import script from "./CartoonDetail.vue?vue&type=script&lang=js"
export * from "./CartoonDetail.vue?vue&type=script&lang=js"
import style0 from "./CartoonDetail.vue?vue&type=style&index=0&id=3683d7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683d7ca",
  null
  
)

export default component.exports